module.exports = __webpack_public_path__ + "media/images/icons/facebook-2-3f2d38fa00dd7f90cc339ac26e3bc996.svg";